// Counter being incremented. JS is single-threaded, so it'll Just Work™.
var __counter = 1;

/**
 * Returns a process-wide unique identifier.
 */
export default function uuid() {
  return "uid-" + __counter++;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-keydown/es/lib/uuid.js
// module id = 285
// module chunks = 0